module.exports = __webpack_public_path__ + "img/art-50.988da530.png";